import { lazy } from 'react';

// Lazy-loaded for code-splitting / performance.
const Home = lazy(() => import('../pages/public/HomePage.jsx'));
const ProductsPage = lazy(() => import('../pages/public/products/ProductsPage.jsx'));
const CategoryProductsPage = lazy(() => import('../pages/public/products/CategoryProductsPage.jsx'));
const BrandProductsPage = lazy(() => import('../pages/public/brands/BrandProductsPage.jsx'));
const ProductDetailPage = lazy(() => import('../pages/public/products/ProductDetailPage.jsx'));
const DealsPage = lazy(() => import('../pages/public/products/DealsPage.jsx'));
const NewArrivalsPage = lazy(() => import('../pages/public/products/NewArrivalsPage.jsx'));
const SearchResultsPage = lazy(() => import('../pages/public/products/SearchResultsPage.jsx'));
const WishlistPage = lazy(() => import('../pages/public/products/WishlistPage.jsx'));
const ComparePage = lazy(() => import('../pages/public/products/ComparePage.jsx'));

const Brands = lazy(() => import('../pages/public/brands/BrandsPage.jsx'));
const BlogListing = lazy(() => import('../pages/public/blog/BlogListingPage.jsx'));
const BlogDetail = lazy(() => import('../pages/public/blog/BlogDetailPage.jsx'));
const BlogCategory = lazy(() => import('../pages/public/blog/BlogCategoryPage.jsx'));
const BlogTag = lazy(() => import('../pages/public/blog/BlogTagPage.jsx'));
const About = lazy(() => import('../pages/public/AboutPage.jsx'));
const Contact = lazy(() => import('../pages/public/ContactPage.jsx'));
const Support = lazy(() => import('../pages/public/SupportPage.jsx'));
const Faq = lazy(() => import('../pages/public/FaqPage.jsx'));
const Cart = lazy(() => import('../pages/public/Cart.jsx'));
const Checkout = lazy(() => import('../pages/public/checkout/CheckoutPage.jsx'));
const CheckoutSuccess = lazy(() => import('../pages/public/checkout/CheckoutSuccessPage.jsx'));
const Inquiry = lazy(() => import('../pages/public/InquiryPage.jsx'));
const PrivacyPolicy = lazy(() => import('../pages/public/PrivacyPolicyPage.jsx'));
const TermsConditions = lazy(() => import('../pages/public/TermsConditionsPage.jsx'));
const ReturnPolicy = lazy(() => import('../pages/public/ReturnPolicyPage.jsx'));
const ShippingPolicy = lazy(() => import('../pages/public/ShippingPolicyPage.jsx'));
const WarrantyPolicy = lazy(() => import('../pages/public/WarrantyPolicyPage.jsx'));
const SitemapPage = lazy(() => import('../pages/public/SitemapPage.jsx'));

const publicRoutes = [
  { path: '/', Component: Home },
  // Product catalog
  { path: '/products', Component: ProductsPage },
  { path: '/category/:slug', Component: CategoryProductsPage },
  { path: '/brand/:slug', Component: BrandProductsPage },
  { path: '/product/:slug', Component: ProductDetailPage },
  { path: '/deals', Component: DealsPage },
  { path: '/new-arrivals', Component: NewArrivalsPage },
  { path: '/search', Component: SearchResultsPage },
  // Wishlist requires login (guests are redirected to /login). Compare is open
  // to guests — it lives entirely in the browser and is never saved to the DB.
  { path: '/wishlist', Component: WishlistPage, requireAuth: true },
  { path: '/compare', Component: ComparePage },

  // Other public pages (untouched)
  { path: '/brands', Component: Brands },
  { path: '/blog', Component: BlogListing },
  { path: '/blog/category/:slug', Component: BlogCategory },
  { path: '/blog/tag/:slug', Component: BlogTag },
  { path: '/blog/:slug', Component: BlogDetail },
  { path: '/about', Component: About },
  { path: '/contact', Component: Contact },
  { path: '/support', Component: Support },
  { path: '/faq', Component: Faq },
  { path: '/cart', Component: Cart },

  { path: '/checkout', Component: Checkout },
  { path: '/checkout/success/:orderNumber', Component: CheckoutSuccess },
  { path: '/inquiry', Component: Inquiry },
  { path: '/privacy-policy', Component: PrivacyPolicy },
  { path: '/terms-conditions', Component: TermsConditions },
  { path: '/return-policy', Component: ReturnPolicy },
  { path: '/shipping-policy', Component: ShippingPolicy },
  { path: '/warranty-policy', Component: WarrantyPolicy },
  { path: '/sitemap', Component: SitemapPage },
];

export default publicRoutes;
